import { MajorDevCourse } from '../../data/builders/major_dev_course_builder';
import { MajorDevCoursesQuery } from '../../data/queries/major_dev_courses_query';

export class MajorDevCoursesViewContentController {
  private devCourses: MajorDevCourse[];

  constructor(private ngMajorDevCoursesQuery: MajorDevCoursesQuery) {
    this.devCourses = this.ngMajorDevCoursesQuery.result;
  }
}

export class MajorDevCoursesViewContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/major_dev_courses_view_content/major_dev_courses_view_content.html';
  public controller: any = MajorDevCoursesViewContentController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/major_dev_courses_view_content/major_dev_courses_view_content_controller.ts